import React from 'react'
import { Division } from './style'

export default () => <Division/>
